import React,{useEffect,useState} from 'react';
import { Container, Row } from 'reactstrap';
import './styles/App.css';
import notification from './img/Frame 162.png'
import workdown from './img/bi_list-check.png'
import manage from './img/bi_people.png'
import control from './img/Frame 163.png'
import management from './img/Frame 590.png'
import product from './img/product.png'
import settings from './img/settings.png'
import TopTitle from './TopTitle';
import Bottom_menu from './Bottom_menu';
import {instance,resetSession} from './common';
import parse from 'html-react-parser';
import { Cookies } from 'react-cookie';

function NewIcon({typed}){
    const iconDiv = {
        backgroundColor:'#D71E21',
        borderRadius:'50%',
        padding:'2px 9px',
        color:'#fff',
        position:'absolute',
        right:'5px',
        top:'-5px'
    }
    const [count, setCount] = useState(0);
    const session = JSON.parse(window.sessionStorage.result);
    useEffect(() => {
        const common = {
            sigong_seq:session.u_sigong,
            
        }
        if(typed === '알림'){
            common.view_check=0
            common.others = 0
        }else{
            common.view_check=0
        }
        instance.post(`/common/v2/condition`,{table:'fcm_push',common:common}).then(function (res) {
            setCount(res.data.length)
        });
    },[])

    return (
        <>
        {
            count > 0
            &&
            <div style={iconDiv}>{count}</div>
        }
        
        </>
    )
}


function StoreManage({history}) {
    const resize = {
        width:'42px'
    }

    const wrap = {
        paddingTop:'15px',
        paddingBottom:'15px',
        borderRadius:'7px',
        border:'3px solid #fff',
        backgroundColor:'#F0F0F0',
        boxShadow: '5px 5px 15px 0px rgba(0,0,0,0.54)',
        color:'#1753A2',
        fontWeight:'bold',
    }

    const session = JSON.parse(window.sessionStorage.result);
    const [popup, setPopup] = useState('');
    const [overlayVisible, setOverlayVisible] = useState(false);


    useEffect(() => {
        
        instance.post('/common/condition', {table:'popup',common:{po_first:'Y'}}).then(function (res) {
            console.log('res : ', res.data)
            if(res.data.length !==0){
                const cookies = new Cookies();
                if(cookies.get('sigong_popup')){

                }else{
                    setPopup(parse(res.data[0].po_content))
                    setOverlayVisible(true)
                }

            }
            
        });
    },[])

    const todayClose = () => {
        const cookies = new Cookies();
        const expires = new Date()
        expires.setDate(expires.getDate() + 1)
        cookies.set('sigong_popup', true, { path: '/', expires });
        setOverlayVisible(false);
    }

    return (
        <>
        {/* 여기에 팝업 나오게끔 작업 */}
            {
                overlayVisible && 
                <>
                <div className='popup-wrap'>
                    {popup}
                    <div className="popup-bottom">
                        <div onClick={() => todayClose()}>오늘은 그만 보기</div>
                        <div onClick={(prev) => setOverlayVisible(!prev)}>닫기</div>
                    </div>
                </div>
                <div className='popupBack'></div>
                </>
            }
            <Container>
                <div className='text-center'>
                <h2 className="text-center font-weight-bold mt-5 mb-5 d-inline-block" style={{fontSize: '22px',borderBottom:'2px solid #D61518',paddingBottom:'7px'}}>{session.u_nick}</h2>
                </div>
                <Row className="mb-5">
                </Row>
                <Row className="mb-5">
                    <div className="col-6 position-relative">
                        <NewIcon typed="알림" />
                        <div className="text-center" style={wrap} onClick={() => history.push('/allim')}>
                            <div className='mt-3 mb-3'>
                            <img src={notification} className="mb-2"  style={resize}/>
                            </div>
                            <span style={{fontSize:'16px'}}>알림</span>
                        </div>
                    </div>
                    <div className="col-6 position-relative">
                        <NewIcon typed="시공지점" />
                        <div className="text-center" style={wrap} onClick={() => {resetSession();history.push('/sigong_list');}}>
                        <div className='mt-3 mb-3'>
                        <img src={workdown} className=""  style={resize}/>
                            </div>
                           
                            <span style={{fontSize:'16px'}}>작업내역</span>
                        </div>
                    </div>
                </Row>
                <Row className="mb-5">
                    <div className="col-6">
                        <div className="text-center" style={wrap} onClick={() => {resetSession();history.push('/maechul-list');}}>
                            <div className='mt-3 mb-3'>
                        <img src={manage} className=""  style={resize}/>
                            </div>
                            
                            <span style={{fontSize:'16px'}}>정산관리</span>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="text-center" style={wrap} onClick={() => history.push('/s_storesetting')}>
                        <div className='mt-3 mb-3'>
                        <img src={management} className=""  style={resize}/>
                            </div>
                            <span style={{fontSize:'16px'}}>매장 정보</span>
                        </div>
                    </div>
                </Row>
                <Row className="">
                    {/* <div className="col-6">
                        <div className="bg-primary text-center" style={wrap} onClick={() => history.push('/product-manage')}>
                            <img src={product} className=""  style={resize}/><br />
                            <span>상품관리</span>
                        </div>
                    </div> */}
                     <div className="col-6">
                        <div className="text-center" style={wrap} onClick={() => alert('서비스 준비중입니다.')}>
                        <div className='mt-3 mb-3'>
                        <img src={product} className=""  style={resize}/>
                            </div>
                            <span style={{fontSize:'16px'}}>상품관리</span>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="text-center" style={wrap} onClick={() => alert('서비스 준비중입니다.')}>
                        <div className='mt-3 mb-3'>
                        <img src={settings} className=""  style={resize}/>
                            </div>
                            <span style={{fontSize:'16px'}}>설정</span>
                        </div>
                    </div>
                </Row>
            </Container>
            <Bottom_menu />
        </>
    );
}

export default StoreManage;